/**
 * Returns whether an OAuth authorize request includes a usable `state` value.
 * `state` is required for CSRF binding between the authorize request and callback.
 */
export const hasRequiredOAuthState = (searchParams: URLSearchParams): boolean => {
  const state = searchParams.get('state');
  return state !== null && state.trim().length > 0;
};
